// extracted by mini-css-extract-plugin
module.exports = {"notice":"style_notice__1jL2X","note":"style_note__VUUxh","titleContainer":"style_titleContainer__3bXdv","title":"style_title__KdTrx","detailLink":"style_detailLink__SC00u"};